exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ancora-youtube[data-v-e097f282]{display:block;margin:15px 0 8px}", ""]);

// exports
